import React from "react";
import {ContentBox, Container} from "../../components/UI";

export default function EarnSpend() {
    return (
        <Container>
            <ContentBox>
                Earn & Spent
            </ContentBox>
        </Container>
    )
}